import React, { useState } from 'react';
import { useQuery } from '@apollo/react-hooks'
import { examsPropertiesQueries } from '../../graphql/queries'
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FiltrosProva from './FiltrosProva';
import FiltrosSimulado from './FiltrosSimulado';
import FiltrosPersonalizados from './FiltrosPersonalizados';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    margin: '40px 0'
  },
  tabsHeader: {
    display: 'flex',
    justifyContent: 'center'
  },
  tabSpacing: {
    padding: '16px',
    '@media(max-width: 1050px)': {
      padding: 0
    }
  }
}));

const ExamsTabs = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const { data } = useQuery(examsPropertiesQueries.GET_SIMULATEDLIST)
  const { data: dataExams } = useQuery(examsPropertiesQueries.GET_EXAMS)

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default" className={classes.tabsHeader}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          aria-label="full width tabs example"
        >
          <Tab disabled={((dataExams || []).provas || []).length ? false : true} label="Prova" {...a11yProps(0)} />
          {((data || {}).simulados || []).length > 0 && <Tab label="Simulado" {...a11yProps(1)} />}
          <Tab disabled={((dataExams || []).provas || []).length ? false : true} label="Personalizada" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction} className={classes.tabSpacing}>
          {((dataExams || []).provas || []).length ? <FiltrosProva /> : <Typography>Nenhuma prova a ser exibida</Typography>}
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction} className={classes.tabSpacing}>
          {((data || {}).simulados || []).length > 0 ? (
            <FiltrosSimulado data={data || {}} />
          ) : (<FiltrosPersonalizados />)}
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction} className={classes.tabSpacing}>
          {((dataExams || []).provas || []).length ? <FiltrosPersonalizados /> : <Typography>Nenhuma prova a ser exibida</Typography>}
        </TabPanel>
      </SwipeableViews>
    </div>
  );
}

export default ExamsTabs
